<template>
  <section class="jsk-block">
    <div class="container">
       <div class="row text-center">
        <div class="col-12">
          <h6 class="text-uppercase text-title">{{ $t("counter.title") }}</h6>
          
        </div>
      </div>
      <div class="row text-center mt-3">
        <div class="col-12 col-lg-3 col-md-6 col-sm-12">
          <p class="text-counter-number">5</p>
          <p>{{ $t("counter.one") }}</p>
        </div>
        <div class="col-12 col-lg-3 col-md-6 col-sm-12">
          <p class="text-counter-number">20+</p>
          <p>{{ $t("counter.two") }}</p>
        </div>
        <div class="col-12 col-lg-3 col-md-6 col-sm-12">
          <p class="text-counter-number">25+</p>
          <p>{{ $t("counter.three") }}</p>
        </div>
        <div class="col-12 col-lg-3 col-md-6 col-sm-12">
          <p class="text-counter-number">50+</p>
          <p>{{ $t("counter.four") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "counterJSK"
};
</script>